import { useWSModal } from "@wingspanhq/fe-component-library";
import { AddClientModal } from ".";

export const useAddClientModal = () =>
  useWSModal(AddClientModal, {
    title: "Add client",
    size: "S",
    onClose() {}
  });
